import util from '@/libs/util'

// 厂站树
export function organizationTree(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/organization/tree',
    params
  })
}

// 企业分页
export function companyPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/organization/page',
    params
  })
}

// 新增企业/厂站
export function companyAdd(data) {
  return util.http({
    method: 'post',
    url: 'org/auth/organization',
    data
  })
}

// parentId查询列表
export function parentIdList(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/common/organization/parentIdList',
    params
  })
}

// 企业信息
export function companyDetail(id) {
  return util.http({
    method: 'get',
    url: `org/auth/company/${id}`
  })
}

// 修改企业
export function companyEdit(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/company',
    data
  })
}

// 删除企业
export function companyDelete(id) {
  return util.http({
    method: 'delete',
    url: `org/auth/company?companyId=${id}`
  })
}

// 锁定/解锁企业
export function companyLock(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/organization/lock',
    data
  })
}

// 企业审批
export function companyApproval(params) {
  return util.http({
    method: 'put',
    url: 'org/auth/company/approval',
    params
  })
}

// 企业申请分页
export function companyApplyPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/company/apply/page',
    params
  })
}

// 生成企业邀请码
export function companyInvitationCode(id) {
  return util.http({
    method: 'put',
    url: `org/auth/company/invitationCode?companyId=${id}`
  })
}

// 企业邀请审批分页
export function companyInvitationApprovalPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyInvitation/approval/page',
    params
  })
}

// 新增企业邀请（邀请码邀请）
export function companyInvitationJoin(data) {
  return util.http({
    method: 'post',
    url: 'org/auth/companyInvitation/join',
    data
  })
}

// 企业邀请信息
export function companyInvitationDetail(id) {
  return util.http({
    method: 'get',
    url: `org/auth/companyInvitation/${id}`
  })
}

// 企业邀请审批
export function companyInvitationApproval(params) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyInvitation/approval',
    params
  })
}

// 企业邀请分页
export function companyInvitationPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyInvitation/page',
    params
  })
}

// 新增企业邀请（企业主动邀请）
export function companyInvitationInvite(data) {
  return util.http({
    method: 'post',
    url: 'org/auth/companyInvitation/invite',
    data
  })
}

// 删除企业邀请
export function companyInvitationDelete(id) {
  return util.http({
    method: 'delete',
    url: `org/auth/companyInvitation?companyInvitationId=${id}`
  })
}

// 企业邀请反馈分页
export function companyInvitationFeedbackPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyInvitation/feedback/page',
    params
  })
}

// 企业邀请反馈
export function companyInvitationFeedback(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyInvitation/feedback',
    data
  })
}

//厂站树
export function deptList(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/dept/list',
    params
  })
}

//厂站新增
export function deptPost(data) {
  return util.http({
    method: 'post',
    url: 'org/auth/dept',
    data
  })
}

//厂站修改
export function deptPut(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/dept',
    data
  })
}

//厂站删除
export function deptDelete(params) {
  return util.http({
    method: 'delete',
    url: 'org/auth/dept',
    params
  })
}

//花名册查询职工列表
export function companyEmployeePage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyEmployee/page',
    params
  })
}

//花名册添加职工
export function companyEmployeeAdd(data) {
  return util.http({
    method: 'post',
    url: 'org/auth/companyEmployee',
    data
  })
}

//花名册删除职工
export function companyEmployeeDelete(params) {
  return util.http({
    method: 'delete',
    url: 'org/auth/companyEmployee',
    params
  })
}

//花名册职工离职
export function companyEmployeeQuit(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyEmployee/resignation',
    data
  })
}
